export class TemperatureEvents {
  static temperatureScaleChanged: string = "TemperatureScaleChanged";
}
